<template>
  <div>
    <div class="columns is-multiline">
      <div class="column is-12">
        <h2 class="title is-4 has-text-white">Nytt Projekt</h2>
      </div>
      <div class="column is-12">
        <BForm :elements="form" @valid="form.valid = $event"></BForm>
      </div>
      <div class="column is-12">
        <Editor
          ref="editor"
          class="has-text-black"
          hideButtons="true"
          html="<i>Beskrivning</i>"
        ></Editor>
      </div>
      <div class="column is-12">
        <ImageUploader
          ref="imageUploader"
          path="upload/card/image"
          css="is-primary"
          btnName="Välj bilder"
          :hideSave="true"
          multiple
        >
          <h1>Lägg till bilder</h1>
          <p>Dra och släpp bilder i denna rutan, eller</p>
        </ImageUploader>
      </div>
    </div>

    <div class="buttons">
      <button
        class="button is-success"
        :disabled="isLoading || !form.valid"
        :class="{ 'is-loading': isLoading }"
        @click="Save()"
      >
        Spara
      </button>
      <button
        class="button"
        @click="
          $emit('input', false);
          $helpers.ClearForm(form);
        "
      >
        Avbryt
      </button>
    </div>
  </div>
</template>

<script>
import BForm from "@/components/singles/BForm/component.vue";
import Editor from "@/components/main/Editor.vue";
import ImageUploader from "@/components/singles/ImageUploader.vue";

export default {
  components: { BForm, Editor, ImageUploader },
  props: ["value", "title"],
  data() {
    return {
      ready: false,
      isLoading: false,
      form: {
        valid: false,
        inputs: [
          {
            icon: "fa-pen",
            name: "title",
            placeholder: "Namn på projekt",
            type: "text",
            label: null,
            validation: "required",
            value: "",
            focus: true
          },
          {
            icon: "fa-pen",
            name: "subtitle",
            placeholder: "Kategori (valfritt)",
            type: "text",
            label: null,
            validation: "",
            value: ""
          }
        ]
      }
    };
  },
  methods: {
    async Save() {
      this.isLoading = true;
      let toSend = {
        pageName: "/projects",
        uid: "",
        object: {
          title: this.form.inputs[0].value,
          subtitle: this.form.inputs[1].value,
          description: this.$refs.editor.$children[0].GetHTML(),
          path: this.$helpers.GetSeoStr(this.form.inputs[0].value),
          active: false
        }
      };

      let result = await this.$helpers.PostApi("set/pageCard", toSend);
      let images = await this.$refs.imageUploader.Save(result[0].uid);

      if (images.length != 0) {
        await this.$helpers.PostApi("set/cardImageCover", {
          cardUID: result[0].uid,
          imageUID: images[0].uid
        });
        images[0].cover = true;
      }
      this.$helpers.ShowStatus("Sparad.", 3000);
      this.isLoading = false;
      this.$emit("saved", { card: result[0], images: images });
    }
  }
};
</script>
